import { Chip, Stack } from '@mui/material';
import { startCase } from 'lodash-es';

interface ChipsProps<T> {
  values: T[];
  getLabel?: (value: T) => string;
  getKey?: (value: T, i: number) => string | number;
  onDelete: (value: T) => void;
}

export default function Chips<T>({ values, getKey, getLabel, onDelete }: ChipsProps<T>) {
  return (
    <Stack
      direction={'row'}
      sx={{
        flexWrap: 'wrap',
        gap: 0.5,
        rowGap: 1
      }}
    >
      {values.map((value, i) => {
        return (
          <Chip
            key={typeof value === 'string' ? value : getKey ? getKey(value, i) : value?.toString()}
            label={startCase(typeof value === 'string' ? value : getLabel ? getLabel(value) : value?.toString())}
            onMouseDown={(event) => event.stopPropagation()}
            onDelete={() => onDelete(value)}
          />
        );
      })}
    </Stack>
  );
}
